import React from 'react';
import Header from '../header.Nomina.component';
import Footer from './footerNomina';
import TerminosCondicionesView from './terminosCondicionesView';


export default function TermsConditions() {
  return (
    <div>
      <Header />
        <TerminosCondicionesView />
      <Footer />
    </div>
  );
}
